<template>
  <section v-bind="sectionProps">
    <!-- @before-slide="beforeSlide" -->
    <vueper-slides v-bind="slidesProps">
      <vueper-slide
        v-for="(slide, i) in slides"
        :key="i"
        :image="loadMedia(slide['slide-image'], 'lg')"
      >
        <template v-slot:content>
          <v-container v-bind="containerProps">
            <v-row v-bind="contentRowProps" ref="slideRow">
              <v-col v-bind="contentColumnProps">
                <div
                  class="slide-title"
                  v-bind="titleProps"
                  v-if="slide['slide-title']"
                  v-inline-editable.html="slide['slide-title']"
                ></div>

                <div
                  class="slide-introtext"
                  v-bind="introtextProps"
                  v-if="slide['slide-introtext']"
                  v-inline-editable.html="slide['slide-introtext']"
                ></div>

                <div
                  v-if="parseBoolean(section.layout['content-box'])"
                  v-bind="contentBoxProps"
                ></div>
              </v-col>
            </v-row>
          </v-container>
        </template>
      </vueper-slide>
    </vueper-slides>

    <slot name="toolbar"></slot>
  </section>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'

export default {
  name: 'SlideshowDefaultSection',
  props: {
    section: {
      type: Object,
      required: true
    },
    templateSettings: {
      type: Object,
      required: true
    },
    builder: {
      type: Boolean,
      default: true
    }
  },
  components: {
    VueperSlide,
    VueperSlides
  },
  computed: {
    slides() {
      return JSON.parse(this.section.content['slides'])
    },
    slidesProps() {
      return {
        fade: true
      }
    },
    sectionProps() {
      return {
        style: {
          paddingTop: 0,
          paddingBottom: 0
        }
      }
    },
    backgroundImageProps() {
      return {
        style: {
          height: '100%',
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        }
      }
    },
    containerProps() {
      return {
        'fill-height': true,
        style: {
          position: 'relative',
          zIndex: 1,
          width: 'calc(100% - 140px)'
        }
      }
    },
    contentRowProps() {
      return {
        'no-gutters': true,
        class: [
          `justify-${this.section.layout['content-horizontal-alignment']}`,
          `text-${this.section.layout['content-horizontal-alignment']}`
        ]
      }
    },
    contentColumnProps() {
      return {
        ...this.calculateColumnContainerSize(
          this.section.layout['content-container-size']
        ),
        style: {
          position: 'relative',
          padding: this.parseBoolean(this.section.layout['content-box'])
            ? this.section.layout['content-box-padding']
            : 0
        }
      }
    },
    titleProps() {
      return {
        is: this.section.design['title-tag'],
        style: {
          color: this.section.design['title-color'],
          fontWeight: this.section.design['title-font-weight']
        }
      }
    },
    introtextProps() {
      return {
        style: {
          color: this.section.design['introtext-color']
        }
      }
    },
    contentBoxProps() {
      let additionalClass = []

      if (this.parseBoolean(this.section.layout['content-box-rounded'])) {
        additionalClass.push('rounded')
      }

      return {
        class: [
          `elevation-${this.section.layout['content-box-elevation']}`,
          ...additionalClass
        ],
        style: {
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: -1,
          backgroundColor: this.section.layout['content-box-color'],
          opacity: this.section.layout['content-box-opacity']
        }
      }
    }
  },
  methods: {
    buttonProps(button) {
      return {
        class: ['mr-3', 'mb-3'],
        depressed: true,
        outlined: button['button-style'] == 'outlined',
        text: button['button-style'] == 'text',
        color:
          button['button-style'] == 'text'
            ? 'transparent'
            : button['button-background-color'],
        style: {
          color: button['button-text-color'],
          borderColor: button['button-background-color']
        }
      }
    }
    // beforeSlide() {
    //   let slideContentHeights = this.$refs.slideRow.map(
    //     slide => slide.clientHeight
    //   )

    //   let largestContent = Math.max.apply(null, slideContentHeights)
    // }
  }
}
</script>

<style>
/* .vueperslides__track,
.vueperslides--fade .vueperslide {
  position: relative;
} */
</style>
